import React, { useContext } from "react";
import { AppContext } from "../../store/AppContext";
import Orders from "./components/Orders/Orders";
import ViewOrder from "./components/ViewOrder/ViewOrder";

const OrdersTab = () => {
  const { orderTabInfo, selectedTab } = useContext(AppContext);

  return (
    <>
      {selectedTab?.subCategory?.index === 0 &&
        (orderTabInfo?.viewOrder || orderTabInfo?.selectedOrder ? (
          <ViewOrder />
        ) : (
          <Orders />
        ))}
    </>
  );
};

export default OrdersTab;
